import { Component, OnInit, Inject} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { DataService } from '../../data.service';
import { AlertService } from '../../services/alert.service';
import { TranslateKeysService } from '../../services/translate-keys.service';
import { WindowService } from 'src/app/services/window.service';
import { SaleType } from 'src/app/Enums/SaleType';


@Component({
  selector: 'app-daily-report-modal',
  templateUrl: './daily-report-modal.component.html',
  styleUrls: ['./daily-report-modal.component.css']
})
export class DailyReportModalComponent implements OnInit {

  waiterName: string;
  noneFiscalSales: number;
  fiscalSales: number;
  totalSales: number;
  fiscalWaiterSales: number;
  noneFiscalWaiterSales: number;
  totalWaiterSales: number;
  normalSales: boolean = true;
  voidSales: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DailyReportModalComponent>,
    protected alertService: AlertService,
    public translateKeys: TranslateKeysService,
    private activatedRoute: ActivatedRoute,
    private api: DataService,
    private windowService: WindowService
  ) { }

  ngOnInit(): void {
    this.waiterName = JSON.parse(localStorage.getItem('waiterObject')).username;
    this.getDailyReport();
  }

  getDailyReport(): void{
    const saleTypes: number[] = [];

    if (this.normalSales) {
      saleTypes.push(SaleType.Sold);
    }

    if (this.voidSales) {
      saleTypes.push(SaleType.Printo);
    }

    this.api.getDailyReport(this.getCompanyID(), this.getUserId(), saleTypes).subscribe((response: any) =>{
      this.noneFiscalSales = response.noneFiscalSales.toFixed(2);
      this.fiscalSales = response.fiscalSales.toFixed(2);
      this.totalSales = response.totalSales.toFixed(2);
      this.fiscalWaiterSales = response.fiscalWaiterSales.toFixed(2);
      this.noneFiscalWaiterSales = response.noneFiscalWaiterSales.toFixed(2);
      this.totalWaiterSales = response.totalWaiterSales.toFixed(2);
    });
  }

  onCheckboxClick(changed: 'normal' | 'void', event: MouseEvent): void {
    const nextNormal = changed === 'normal' ? !this.normalSales : this.normalSales;
    const nextVoid = changed === 'void' ? !this.voidSales : this.voidSales;
  
    if (!nextNormal && !nextVoid) {
      event.preventDefault();
      return;
    }
  
    // Only update if valid
    if (changed === 'normal') {
      this.normalSales = !this.normalSales;
    } else {
      this.voidSales = !this.voidSales;
    }

    this.getDailyReport();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  getUserId() {
    return this.api.getWaiterID();
  }

  getCompanyID() {
    return JSON.parse(localStorage.getItem('waiterObject')).companyID;
  }

  closeReport(){
    this.api.closeReport(this.getCompanyID(), this.getUserId()).subscribe((response: any) =>{
      this.closeDialog();
      if(response == true){
        this.alertService.swalFire(
          'success',
          this.translateKeys.doTranslate('CLOSED_DAYSHIFT_SUCCESS'),
          true,
          false,
          this.translateKeys.doTranslate('CLOSE'),
          ''
          )
      }
    });
}

  printDailyReport(){
    this.windowService.windowRef.location = `crm:/15/${this.getCompanyID()}/${this.getUserId()}`;
  }

}
